import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnauthPagesComponent } from '@foo/foo-web-framework/shared-modules/layout';
import { DeepLinkRedirectComponent } from './components/deep-link-redirect/deep-link-redirect.component';

const routes: Routes = [
  {
    path: '',
    component: UnauthPagesComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/pre-onboarding/pre-onboarding.module').then(m => m.PreOnboardingModule)
      },
      {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AECAuthModule)
      },
      {
        path: 'apps',
        component: DeepLinkRedirectComponent
      }
    ]
  },
  {
    path: '',
    pathMatch: 'prefix',
    loadChildren: () => import('@foo/wallet-web-framework').then(m => m.WalletWebFrameworkModule)
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
